import { errorMsg } from '../../utils/errorMsg';
import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, Card, CardContent, Grid,
  Chip, Avatar, Button, CircularProgress, Alert, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField,
  MenuItem, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Snackbar,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ChurchIcon from '@mui/icons-material/Church';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import TimelineIcon from '@mui/icons-material/Timeline';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import FavoriteIcon from '@mui/icons-material/Favorite';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import IconButton from '@mui/material/IconButton';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ContextNavBar from '../../components/ContextNavBar';
import api from '../../axios';
import { getJornadaMembro, atualizarJornada } from '../../api/jornada';

const LIME = '#00F1A7';
const formatarData = (data) => {
  if (!data) return '-';
  const d = data.slice(0, 10);
  if (!d) return '-';
  const partes = d.split('-');
  if (partes.length !== 3) return d;
  return `${partes[2]}/${partes[1]}/${partes[0]}`;
};
const DARK = '#1C1C1E';

const ESTADO_CIVIL_OPCOES = [
  'Solteiro(a)', 'Casado(a)', 'Divorciado(a)', 'Viuvo(a)', 'Uniao estavel',
];

export default function JornadaMembro() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [editOpen, setEditOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [snack, setSnack] = useState('');
  const [form, setForm] = useState({});
  const [filhos, setFilhos] = useState([]);
  const [filhoDialog, setFilhoDialog] = useState({ open: false, edit: null, nome: '', data_nascimento: '', observacoes: '' });

  const fetch = () => {
    setLoading(true);
    setErro('');
    getJornadaMembro(id)
      .then(setData)
      .catch(() => setErro('Nao foi possivel carregar a jornada do membro.'))
      .finally(() => setLoading(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetch(); carregarFilhos(); }, [id]);

  const carregarFilhos = async () => {
    try { const r = await api.get(`/jornada/membro/${id}/filhos`); setFilhos(r.data || []); } catch {}
  };

  const abrirNovoFilho = () => setFilhoDialog({ open: true, edit: null, nome: '', data_nascimento: '', observacoes: '' });
  const abrirEditarFilho = (f) => setFilhoDialog({ open: true, edit: f, nome: f.nome, data_nascimento: (f.data_nascimento || '').slice(0, 10), observacoes: f.observacoes || '' });

  const salvarFilho = async () => {
    if (!filhoDialog.nome.trim()) return;
    try {
      const payload = { nome: filhoDialog.nome, data_nascimento: filhoDialog.data_nascimento || '', observacoes: filhoDialog.observacoes || '' };
      if (filhoDialog.edit)
        await api.put(`/jornada/filhos/${filhoDialog.edit.id}`, payload);
      else
        await api.post(`/jornada/membro/${id}/filhos`, payload);
      setFilhoDialog({ ...filhoDialog, open: false });
      carregarFilhos();
    } catch (err) { alert(errorMsg(err) || 'Erro ao salvar filho'); }
  };

  const deletarFilho = async (filhoId) => {
    if (!window.confirm('Remover filho?')) return;
    try { await api.delete(`/jornada/filhos/${filhoId}`); carregarFilhos(); } catch {}
  };

  const openEdit = () => {
    const j = data?.jornada || {};
    setForm({
      igreja_origem: j.igreja_origem || '',
      data_primeira_visita: (j.data_primeira_visita || '').slice(0, 10),
      data_decisao: (j.data_decisao || '').slice(0, 10),
      data_batismo: (j.data_batismo || '').slice(0, 10),
      estado_civil: j.estado_civil || '',
      conjuge_nome: j.conjuge_nome || '',
      fez_start: j.fez_start || '',
      funcao_atual: j.funcao_atual || '',
      motivo_afastamento: j.motivo_afastamento || '',
      observacoes: j.observacoes || '',
    });
    setEditOpen(true);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await atualizarJornada(id, form);
      setSnack('Jornada atualizada com sucesso!');
      setEditOpen(false);
      fetch();
    } catch (err) {
      setSnack(errorMsg(err) || 'Erro ao salvar jornada.');
    }
    setSaving(false);
  };

  if (loading) {
    return (
      <>
        <Header />
        <ContextNavBar context="jornada" />
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 }, textAlign: 'center' }}>
          <CircularProgress />
        </Container>
        <Footer />
      </>
    );
  }

  if (erro) {
    return (
      <>
        <Header />
        <ContextNavBar context="jornada" />
        <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
          <Alert severity="error">{erro}</Alert>
        </Container>
        <Footer />
      </>
    );
  }

  if (!data) return null;

  const { membro, jornada, discipulador, discipulados, gc, cursos } = data;

  const temDiscipulador = !!discipulador;
  const temGC = !!gc;

  const etapas = [
    { chave: 'visitante', titulo: 'Visitante', data: jornada?.data_primeira_visita || null, feita: !!jornada?.data_primeira_visita },
    { chave: 'consolidacao', titulo: 'Consolidacao', data: jornada?.data_decisao || null, feita: !!jornada?.data_decisao },
    { chave: 'start', titulo: 'Start (Aluno)', data: membro?.data_matricula || null, feita: membro?.fez_start === 'Sim' || !!membro?.data_matricula },
    { chave: 'membro', titulo: 'Membro', data: jornada?.data_batismo || null, feita: !!jornada?.data_batismo },
    { chave: 'discipulado', titulo: 'Discipulado', data: null, feita: temDiscipulador, detalhe: discipulador?.nome_discipulador || null },
    { chave: 'gc', titulo: 'Grupo de Crescimento', data: null, feita: temGC, detalhe: gc?.nome || null },
    { chave: 'cursos', titulo: 'Cursos', data: null, feita: cursos && cursos.length > 0, detalhe: cursos ? `${cursos.length} curso(s)` : null },
  ];

  return (
    <>
      <Header />
      <ContextNavBar context="jornada" />
      <Container maxWidth="md" sx={{ py: { xs: 2, md: 4 }, px: { xs: 1, md: 2 } }}>
        <Snackbar
          open={!!snack}
          autoHideDuration={4000}
          onClose={() => setSnack('')}
          message={snack}
        />


        <Card sx={{ mb: 3, bgcolor: DARK, color: '#fff' }}>
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexDirection: { xs: 'column', md: 'row' } }}>
              <Avatar sx={{ bgcolor: LIME, color: DARK, width: 56, height: 56, fontSize: 24 }}>
                {(membro?.nome || '?').charAt(0).toUpperCase()}
              </Avatar>
              <Box sx={{ flex: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
                  {membro?.nome || 'Membro'}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                  <Chip
                    icon={<GroupIcon />}
                    label={temDiscipulador ? 'Tem discipulador' : 'Sem discipulador'}
                    size="small"
                    sx={{ bgcolor: temDiscipulador ? LIME : '#555', color: temDiscipulador ? DARK : '#ccc' }}
                  />
                  <Chip
                    icon={<ChurchIcon />}
                    label={temGC ? 'Em GC' : 'Sem GC'}
                    size="small"
                    sx={{ bgcolor: temGC ? LIME : '#555', color: temGC ? DARK : '#ccc' }}
                  />
                </Box>
              </Box>
              <Button
                variant="outlined"
                startIcon={<EditIcon />}
                onClick={openEdit}
                sx={{ color: '#fff', borderColor: '#fff', '&:hover': { borderColor: LIME, color: LIME } }}
              >
                Editar
              </Button>
            </Box>
          </CardContent>
        </Card>

        <Grid container spacing={3}>
          {/* Secao 1: Origem e Decisao */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ChurchIcon sx={{ color: LIME }} /> Origem e Decisao
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Igreja de origem</Typography>
                    <Typography variant="body2">{jornada?.igreja_origem || '-'}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Data primeira visita</Typography>
                    <Typography variant="body2">{formatarData(jornada?.data_primeira_visita) || '-'}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Data Decisão</Typography>
                    <Typography variant="body2">{formatarData(jornada?.data_decisao) || '-'}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Data Batismo</Typography>
                    <Typography variant="body2">{formatarData(jornada?.data_batismo) || '-'}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Estado civil</Typography>
                    <Typography variant="body2">{jornada?.estado_civil || '-'}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Conjuge</Typography>
                    <Typography variant="body2">{jornada?.conjuge_nome || '-'}</Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Fez o Start?</Typography>
                    <Typography variant="body2">{jornada?.fez_start || '-'}</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Secao 2: Acompanhamento Atual */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <PeopleIcon sx={{ color: LIME }} /> Acompanhamento Atual
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Discipulador</Typography>
                    {discipulador ? (
                      <Typography
                        variant="body2"
                        sx={{ color: '#1976d2', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                        onClick={() => navigate(`/jornada/membro/${discipulador.id}`)}
                      >
                        {discipulador.nome}
                      </Typography>
                    ) : (
                      <Typography variant="body2" color="error">Nenhum</Typography>
                    )}
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Pessoas que discipula</Typography>
                    {discipulados && discipulados.length > 0 ? (
                      discipulados.map((d, i) => (
                        <Typography
                          key={d.id || i}
                          variant="body2"
                          sx={{ color: '#1976d2', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                          onClick={() => navigate(`/discipulados/${d.id}`)}
                        >
                          {d.discipulando_nome}
                        </Typography>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">Nenhum</Typography>
                    )}
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">GC atual</Typography>
                    {gc ? (
                      <Typography variant="body2">{gc.nome}</Typography>
                    ) : (
                      <Typography variant="body2" color="text.secondary">Nenhum</Typography>
                    )}
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">Funcao atual</Typography>
                    <Typography variant="body2">{jornada?.funcao_atual || '-'}</Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* Secao 3: Cursos e Treinamentos */}
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <SchoolIcon sx={{ color: LIME }} /> Cursos e Treinamentos
                </Typography>
                {cursos && cursos.length > 0 ? (
                  <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Curso</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Data conclusao</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {cursos.map((c, i) => (
                          <TableRow key={c.curso_id || i}>
                            <TableCell>
                              <Typography
                                variant="body2"
                                sx={{ color: '#1976d2', cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                                onClick={() => navigate(`/cursos/${c.id}`)}
                              >
                                {c.titulo}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Chip
                                label={c.status || 'Pendente'}
                                size="small"
                                color={c.status === 'Concluido' ? 'success' : c.status === 'Em andamento' ? 'info' : 'default'}
                              />
                            </TableCell>
                            <TableCell>{c.data_conclusao || '-'}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Typography variant="body2" color="text.secondary">Nenhum curso registrado.</Typography>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Secao 4: Linha do Tempo */}
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <TimelineIcon sx={{ color: LIME }} /> Linha do Tempo
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  {etapas.map((etapa, i) => (
                    <Box key={etapa.chave} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Avatar
                          sx={{
                            bgcolor: etapa.feita ? LIME : '#e0e0e0',
                            width: 36,
                            height: 36,
                            color: etapa.feita ? '#fff' : '#999',
                          }}
                        >
                          {iconesTimeline(etapa.chave)}
                        </Avatar>
                        {i < etapas.length - 1 && (
                          <Box
                            sx={{
                              width: 2,
                              height: 32,
                              bgcolor: etapa.feita ? LIME : '#e0e0e0',
                              mt: 0.5,
                            }}
                          />
                        )}
                      </Box>
                      <Box sx={{ pt: 0.5 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: etapa.feita ? DARK : '#999' }}>
                          {etapa.titulo}
                        </Typography>
                        {etapa.data && (
                          <Typography variant="caption" color="text.secondary">
                            {etapa.data}
                          </Typography>
                        )}
                        {etapa.detalhe && (
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                            {etapa.detalhe}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Modal Editar Jornada */}
        <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Editar Jornada</DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              <TextField
                label="Igreja de origem"
                fullWidth
                size="small"
                value={form.igreja_origem}
                onChange={(e) => setForm({ ...form, igreja_origem: e.target.value })}
              />
              <TextField
                label="Data primeira visita"
                type="date"
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                value={form.data_primeira_visita}
                onChange={(e) => setForm({ ...form, data_primeira_visita: e.target.value })}
              />
              <TextField
                label="Data decisao"
                type="date"
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                value={form.data_decisao}
                onChange={(e) => setForm({ ...form, data_decisao: e.target.value })}
              />
              <TextField
                label="Data batismo"
                type="date"
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                value={form.data_batismo}
                onChange={(e) => setForm({ ...form, data_batismo: e.target.value })}
              />
              <TextField
                label="Estado civil"
                select
                fullWidth
                size="small"
                value={form.estado_civil}
                onChange={(e) => setForm({ ...form, estado_civil: e.target.value })}
              >
                <MenuItem value="">Nenhum</MenuItem>
                {ESTADO_CIVIL_OPCOES.map((op) => (
                  <MenuItem key={op} value={op}>{op}</MenuItem>
                ))}
              </TextField>
              <TextField
                label="Nome do conjuge"
                fullWidth
                size="small"
                value={form.conjuge_nome}
                onChange={(e) => setForm({ ...form, conjuge_nome: e.target.value })}
              />
              <TextField
                label="Fez o Start?"
                select
                fullWidth
                size="small"
                value={form.fez_start}
                onChange={(e) => setForm({ ...form, fez_start: e.target.value })}
              >
                <MenuItem value="">-</MenuItem>
                <MenuItem value="Sim">Sim</MenuItem>
                <MenuItem value="Nao">Nao</MenuItem>
              </TextField>
              <TextField
                label="Funcao atual"
                fullWidth
                size="small"
                value={form.funcao_atual}
                onChange={(e) => setForm({ ...form, funcao_atual: e.target.value })}
              />
              <TextField
                label="Motivo de afastamento"
                fullWidth
                size="small"
                multiline
                rows={2}
                value={form.motivo_afastamento}
                onChange={(e) => setForm({ ...form, motivo_afastamento: e.target.value })}
              />
              <TextField
                label="Observacoes"
                fullWidth
                size="small"
                multiline
                rows={3}
                value={form.observacoes}
                onChange={(e) => setForm({ ...form, observacoes: e.target.value })}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditOpen(false)} disabled={saving}>Cancelar</Button>
            <Button variant="contained" onClick={handleSave} disabled={saving}>
              {saving ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Seção Filhos */}
        <Box sx={{ mt: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 1, md: 2 } }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>Filhos</Typography>
            <Button size="small" startIcon={<AddIcon />} onClick={abrirNovoFilho}>Adicionar Filho</Button>
          </Box>
          {filhos.length === 0 ? (
            <Typography variant="body2" color="text.secondary">Nenhum filho registrado.</Typography>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              {filhos.map(f => (
                <Paper key={f.id} sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>{f.nome}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {f.data_nascimento ? `Nascimento: ${formatarData(f.data_nascimento)}` : ''}
                      {f.observacoes ? ` • ${f.observacoes}` : ''}
                    </Typography>
                  </Box>
                  <Box>
                    <IconButton size="small" onClick={() => abrirEditarFilho(f)}><EditIcon fontSize="small" /></IconButton>
                    <IconButton size="small" color="error" onClick={() => deletarFilho(f.id)}><DeleteIcon fontSize="small" /></IconButton>
                  </Box>
                </Paper>
              ))}
            </Box>
          )}
        </Box>

        {/* Dialog para adicionar/editar filho */}
        <Dialog open={filhoDialog.open} onClose={() => setFilhoDialog({ ...filhoDialog, open: false })} maxWidth="sm" fullWidth>
          <DialogTitle>{filhoDialog.edit ? 'Editar Filho' : 'Adicionar Filho'}</DialogTitle>
          <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
            <TextField label="Nome" value={filhoDialog.nome} onChange={e => setFilhoDialog(f => ({ ...f, nome: e.target.value }))} fullWidth required />
            <TextField label="Data de Nascimento" type="date" value={filhoDialog.data_nascimento} onChange={e => setFilhoDialog(f => ({ ...f, data_nascimento: e.target.value }))} fullWidth InputLabelProps={{ shrink: true }} />
            <TextField label="Observações" value={filhoDialog.observacoes} onChange={e => setFilhoDialog(f => ({ ...f, observacoes: e.target.value }))} fullWidth multiline rows={2} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setFilhoDialog({ ...filhoDialog, open: false })}>Cancelar</Button>
            <Button variant="contained" onClick={salvarFilho}>Salvar</Button>
          </DialogActions>
        </Dialog>
      </Container>
      <Footer />
    </>
  );
}

function iconesTimeline(chave) {
  switch (chave) {
    case 'visitante': return <EmojiPeopleIcon fontSize="small" />;
    case 'consolidacao': return <FavoriteIcon fontSize="small" />;
    case 'start': return <SchoolIcon fontSize="small" />;
    case 'membro': return <PersonIcon fontSize="small" />;
    case 'discipulado': return <GroupIcon fontSize="small" />;
    case 'gc': return <ChurchIcon fontSize="small" />;
    case 'cursos': return <AutoStoriesIcon fontSize="small" />;
    default: return <TimelineIcon fontSize="small" />;
  }
}
